export default __webpack_public_path__ + "media/images/friends-cropped-465cae170b4360fef891b82c3c78add4.png";